import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'
import {SubsidiaryPageModel} from '../Model/SubsidiaryPageModel'
import { SortSubsidiaryPageActionModel, SortSubsidiaryPageModel } from '../Model'

function* getSubsidiaryPageSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getSubsidiaryPage, params)
    yield put(actions.getSubsidiaryPageSuccess(response?.data?.data))
    yield put(actions.getSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getSubsidiaryPageFinish())
  }
}

function* getAllSubsidiaryPageSaga() {
  try {
    const response: ResponseModel = yield call(service.getAllSubsidiaryPage)
    yield put(actions.getAllSubsidiaryPageSuccess(response?.data?.data))
    yield put(actions.getAllSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getAllSubsidiaryPageFinish())
  }
}

function* addSubsidiaryPageSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addSubsidiaryPage, body)
    yield put(actions.addSubsidiaryPageSuccess(response.data?.data))
    yield put(actions.addSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addSubsidiaryPageFinish())
  }
}

function* enableSubsidiaryPageSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableSubsidiaryPage, selectedUsers)
    yield put(actions.enableSubsidiaryPageSuccess(response?.data))
    yield put(actions.enableSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableSubsidiaryPageFinish())
  }
}

function* disableSubsidiaryPageSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableSubsidiaryPage, selectedUsers)
    yield put(actions.disableSubsidiaryPageSuccess(response?.data))
    yield put(actions.disableSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableSubsidiaryPageFinish())
  }
}

function* singleEnableSubsidiaryPageSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableSubsidiaryPage, selectedUsers)
    yield put(actions.singleEnableSubsidiaryPageSuccess(response?.data))
    yield put(actions.singleEnableSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleEnableSubsidiaryPageFinish())
  }
}

function* singleDisableSubsidiaryPageSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableSubsidiaryPage, selectedUsers)
    yield put(actions.singleDisableSubsidiaryPageSuccess(response?.data))
    yield put(actions.singleDisableSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleDisableSubsidiaryPageFinish())
  }
}

function* updateSubsidiaryPageSaga(action: ActionModel) {
  try {
    const body: SubsidiaryPageModel = action.payload
    const response: ResponseModel = yield call(
      service.updateSubsidiaryPage,
      body,
      action.payload?.id
    )
    yield put(actions.updateSubsidiaryPageSuccess(response.data?.data))
    yield put(actions.updateSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateSubsidiaryPageFinish())
  }
}

function* deleteSubsidiaryPageSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteSubsidiaryPage, body)
    yield put(actions.deleteSubsidiaryPageSuccess(response.data?.data))
    yield put(actions.deleteSubsidiaryPageFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteSubsidiaryPageFinish())
  }
}

function* sortSubsidiaryPage(action: SortSubsidiaryPageActionModel) {
  try {
    const body: SortSubsidiaryPageModel = action.payload
    const response: ResponseModel = yield call(service.sortSubsidiaryPage, body)

    yield put({
      type: actionTypes.SORT_SUBSIDIARY_PAGE_SUCCESS,
      payload: response?.data?.data,
    })
    yield put({type: actionTypes.SORT_SUBSIDIARY_PAGE_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SORT_SUBSIDIARY_PAGE_FINISH})
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_SUBSIDIARY_PAGE_START, getSubsidiaryPageSaga)
  yield takeLatest(actionTypes.GET_ALL_SUBSIDIARY_PAGE_START, getAllSubsidiaryPageSaga)
  yield takeLatest(actionTypes.ADD_SUBSIDIARY_PAGE_START, addSubsidiaryPageSaga)
  yield takeLatest(actionTypes.UPDATE_SUBSIDIARY_PAGE_START, updateSubsidiaryPageSaga)
  yield takeLatest(actionTypes.DELETE_SUBSIDIARY_PAGE_START, deleteSubsidiaryPageSaga)
  yield takeLatest(actionTypes.ENABLE_SUBSIDIARY_PAGE_REQUEST, enableSubsidiaryPageSaga)
  yield takeLatest(actionTypes.DISABLE_SUBSIDIARY_PAGE_REQUEST, disableSubsidiaryPageSaga)
  yield takeLatest(
    actionTypes.SINGLE_ENABLE_SUBSIDIARY_PAGE_REQUEST,
    singleEnableSubsidiaryPageSaga
  )
  yield takeLatest(
    actionTypes.SINGLE_DISABLE_SUBSIDIARY_PAGE_REQUEST,
    singleDisableSubsidiaryPageSaga
  )

  yield takeLatest(actionTypes.SORT_SUBSIDIARY_PAGE_START, sortSubsidiaryPage)
}
